import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Sidebar from './SidebarWriter';

class Layout extends Component {
    static displayName = Layout.name;

    render() {
        const { location } = this.props;
        const pathname = location && location.pathname;
        const isWriterHome =
            pathname === '/WriterClient/WriterMainMenu';
        const hideSidebarOnTextDetails = pathname === '/WriterClient/TextDetails';
        const shellClassName = isWriterHome
            ? 'app-shell app-shell--writer-home'
            : 'app-shell';
        return (
            <div>
                <div className={shellClassName}>
                    {!hideSidebarOnTextDetails && <Sidebar />}
                    <div className="wrapper-content">
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Layout);

